import {useState, useEffect} from 'react';
import FormGroup from "./FormGroup"

const ColorPicker = (props) => {
    const [data, setData] = useState(props.value || "#ffffff");
    
    const onChange = (e) => {
        setData(e.target.value);
        props.onChange(props.id, e.target.value);
    }

    useEffect(() => {
        setData(props.value || "#ffffff");
    }, [props.value]);

    useEffect(() => {
        if(props.onLoad) {
            props.onLoad();
        }
    }, [])
  
    return (
        <FormGroup {...props}>
            <input 
                type="color" 
                id={props.id}
                name={props.id}
                className="form-control color-picker-input"
                onChange={onChange}
                value={data}
            />
        </FormGroup>
    )
}

export default ColorPicker;
